import checkBaseLayout from '@/components/checkLayout/checkBaseLayout'
import checkModule from '@/components/checkLayout/module/checkModule'
import compartModule from '@/components/checkLayout/module/compartModule'
import infoTable from '@/components/module/infoTable'
import checkInfoModule from '@/components/checkLayout/module/checkInfoModule'
import supplierModule from '@/components/checkLayout/module/supplierModule'
import customerModule from '@/components/checkLayout/module/customerModule'
import pactModule from '@/components/checkLayout/module/pactModule'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    snaId: {
      type: String,
      default: ''
    }
  },
  components: {
    checkBaseLayout,
    checkModule,
    compartModule,
    infoTable,
    supplierModule,
    checkInfoModule,
    pactModule,
    customerModule
  },
  data () {
    return {
      checkFrom: {} // 审批信息对象
    }
  },
  methods: {
    // 格式化table的数据 ==> 接口返回对象
    formatTableData (data) {
      return Array.isArray(data) ? data : [data]
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 统一格式化参数入口
    formatterData (data) {
      return this.formatterApplicants(data)
    },
    // 统一申请人信息
    formatterApplicants (data) {
      const purchaseBaseApprovalsVo = data.purchaseBaseApprovalsVo
      if (!purchaseBaseApprovalsVo) return data
      const {
        createDate,
        createUser,
        mark,
        orgName
      } = purchaseBaseApprovalsVo
      return Object.assign(data, {
        createDate,
        createUser,
        mark,
        orgName
      })
    },
    // 统一供应商信息
    formatterSupplierInfo (data) {
      const supplierAccountContentVo = data.supplierAccountContentVo // 原供应商信息
      if (!supplierAccountContentVo) return data
      const supplierAccountBase = supplierAccountContentVo.supplierAccountBase || {} // 账款信息
      const supplierConnect = supplierAccountContentVo.supplierConnect || {} // 联系方式
      Object.assign(data.supplierAccountContentVo, {
        performInfo: supplierAccountContentVo.ingCount,
        performSuc: supplierAccountContentVo.endCount,
        purchaseTotal: supplierAccountContentVo.contractTotal,
        deductionAmount: supplierAccountBase.deductionAmount,
        accountBalance: supplierAccountBase.accountBalance,
        accountsDue: supplierAccountBase.accountsDue,
        accountsOutstanding: supplierAccountBase.accountsOutstanding,
        staffCnName: supplierConnect.suContacts,
        staffPhone: supplierConnect.suPhone,
        staffMobilePhone: supplierConnect.suMobile,
        address: supplierAccountContentVo.suAddress,
        accountsPayable: supplierAccountBase.accountsPayable,
        actualTotal: supplierAccountBase.accountsPaid,
        suId: supplierAccountBase.suId
      })
      return data
    },
    // 验证是否请求成功
    isSuccess (res) {
      return res.data.code === 200
    }
  }
}
